import {defineStore} from "pinia";

export const useWindowStore = defineStore("window", {
  state: () => ({
    windowWidth: window.innerWidth
  }),

  actions: {
    handleResize(){
      this.windowWidth = window.innerWidth
    }
  },
  getters: {
    isDesktop(){
      return this.windowWidth > 700
    }
  }

});


